import React from "react";
import PropTypes from "prop-types";
import "../../Styles/TestimonialCard.css";



export default function TestimonialCard({ id, quote, name, title, avatarUrl }) {
  return (
    <figure className="testimonial-card" aria-labelledby={`t-${id}-name`}>
      {/* large faint quote mark for visual effect */}
      <svg className="testimonial-quote" viewBox="0 0 24 24" aria-hidden>
        <path
          d="M7.5 3c-2.43 0-4.5 2.02-4.5 4.5 0 3.3 2 6 2 8.5H9c0-3.6-1.8-6.1-1.5-10 0-1.6 0.6-3 0.6-3.5C8.1 3.3 7.9 3 7.5 3zM18.5 3c-2.43 0-4.5 2.02-4.5 4.5 0 3.3 2 6 2 8.5H20c0-3.6-1.8-6.1-1.5-10 0-1.6 0.6-3 0.6-3.5C19.1 3.3 18.9 3 18.5 3z"
          fill="currentColor"
          fillRule="nonzero"
        />
      </svg>

      <figcaption className="testimonial-body">
        <p className="testimonial-text">{quote}</p>
      </figcaption>

      <div className="testimonial-chip" id={`t-${id}-name`}>
        <img className="testimonial-avatar" src={avatarUrl} alt={`${name} avatar`} />
        <div className="testimonial-meta">
          <div className="testimonial-name">{name}</div>
          <div className="testimonial-title">{title}</div>
        </div>
      </div>
    </figure>
  );
}

TestimonialCard.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  quote: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  title: PropTypes.string,
  avatarUrl: PropTypes.string,
};

TestimonialCard.defaultProps = {
  title: "",
  avatarUrl: "https://placehold.co/48x48?text=👤",
};